<template>
	<div class="ma-3">
		<v-progress-linear indeterminate color="accent" v-if="loading"></v-progress-linear>
		<v-container fluid pa-0 ma-0 v-if="ticketDto != null">
			<v-layout column>
				<v-flex>
					<h1>Beanstandung zum Auftrag {{ ticketDto ? ticketDto.orderId : "" }}</h1>
				</v-flex>
				<v-flex mt-3>
					<v-tabs slider-color="accent">
						<v-tab v-for="(complain, index) in ticketDto.complains" :key="index">
							Position {{ complain.position }}
						</v-tab>
						<v-tab-item v-for="(complain, index) in ticketDto.complains" :key="index">
							<ticket-position
								:readonly="ticketDto.manufacturerHasDecided"
								:complaintDto="complain"
							></ticket-position>
						</v-tab-item>
					</v-tabs>
					<v-btn
						class="blexon-button"
						:disabled="ticketDto.manufacturerHasDecided"
						@click="closeTicket()"
					>
						Abschliessen
					</v-btn>
					<span v-if="error.length > 0" style="color: red" v-html="error"></span>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";
import TicketPosition from "./ticketPositionComponent.vue";

export default {
	components: {
		"ticket-position": TicketPosition,
	},

	data() {
		return {
			loading: false,
			ticketDto: null,
			error: "",
		};
	},
	computed: {
		ticketId() {
			return this.$route.params.id;
		},
	},
	mounted() {
		this.loadTicket();
	},

	methods: {
		async loadTicket() {
			try {
				this.loading = true;
				var response = await httpClient().get(
					`api/ticket/getTicket?ticketId=${this.ticketId}`
				);
				this.ticketDto = response.data;
			} catch {
				console.error("Load ticket failed");
			} finally {
				this.loading = false;
			}
		},
		async closeTicket() {
			this.error = "";
			for (const complain of this.ticketDto.complains) {
				if (complain.fertigerComplaintResponse <= 0) {
					this.error += `Beanstandung der Position ${complain.position} ist noch nicht festgelegt.`;
				}
				if (
					complain.fertigerComplaintResponse == 1 &&
					!(
						complain.fertigerDeclineExplanation &&
						complain.fertigerDeclineExplanation.length > 3
					)
				) {
					this.error += `Begründung für Ablehnung der Beanstandung für Position ${complain.position} fehlt.`;
				}
			}
			if (this.error.length > 0) {
				return;
			}

			try {
				this.loading = true;
				await httpClient().post(`api/ticket/closeTicket?ticketId=${this.ticketId}`);
				this.ticketDto.manufacturerHasDecided = true;
				this.$router.push({
					name: "tickets",
					params: { fertigerId: this.$route.params.fertigerId },
				});
			} catch {
				console.error("Close ticket failed");
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
